import { ReactNode } from "react";
import PersonalImg from "assets/images/img_personal.png";
import ProcessingImg from "assets/images/img_processing.png";
import QnaImg from "assets/images/img_qna.png";

type PricacyTypes = {
  revision: string;
  content: ReactNode;
};

const privacies: PricacyTypes[] = [
  {
    revision: "2023년 08월 28일",
    content: (
      <>
        <p className="txt">
          본 개인정보처리방침은 SK플래닛 주식회사(이하 “회사”라 함)가 제공하는 Planet AD(이하 ‘서비스’라 합니다)이/가 고객님께 서비스를 제공하는 과정에서 수집 ·
          저장되어 처리하고 있는 개인정보의 관리 방법과 현황에 대해 안내드리고자 제정되었습니다
        </p>
        <ol>
          <li>개인정보의 수집/이용목적 · 항목 및 보유기간</li>
          <li>수집한 개인정보의 이용 및 제3자 제공</li>
          <li>개인정보의 처리 위탁</li>
          <li>개인정보의 국외 이전에 관한 사항</li>
          <li>개인정보 파기절차 및 방법</li>
          <li>정보주체 및 법정대리인의 권리 · 의무와 그 행사방법</li>
          <li>개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</li>
          <li>개인정보의 기술적/관리적 보호 대책</li>
          <li>광고성 정보 전송</li>
          <li>개인정보 관련 불편처리</li>
          <li>개인정보보호책임자 및 담당자의 연락처</li>
          <li>행태정보의 수집 · 이용 · 제공 및 거부 등에</li>
          <li>추가적인 이용 · 제공 관련 판단 기준</li>
          <li>가명정보 처리에 관한 사항</li>
          <li>개인위치정보 수집 · 이용 · 제공 등에 관한 사항</li>
          <li>알릴의무</li>
        </ol>
        <p className="txt">
          회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보보호법」 등 개인정보 보호에 관한 국내법에 따라 고객의 개인정보를 안전하게
          관리하기 위한 최선의 노력을 다하고 있으며, 각 각의 구체적인 관리방법은 다음과 같습니다.
        </p>
        <hr />
        <div className="wrap_detail">
          <strong className="txt_title">1. 개인정보의 수집/이용목적·항목 및 보유기간</strong>
          <p className="txt">회사는 개인정보의 처리 목적에 따라 필요한 최소한의 개인정보만 수집∙이용(처리)하고 있습니다.</p>
          <div className="wrap_sub">
            <p className="txt_num">
              <span className="num">1)</span> [필수] 개인정보 수집/이용
            </p>
            <table className="tbl">
              <thead>
                <tr>
                  <th>목적</th>
                  <th>항목</th>
                  <th>보유기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>광고 적립금 관련 고객 문의사항 처리</td>
                  <td>이메일, 문의 내용</td>
                  <td>문의일로부터 3년 보관 후 파기</td>
                </tr>
              </tbody>
            </table>
            <p className="txt_num">
              <span className="num">2)</span> 만 14세 미만 아동의 개인정보 처리에 관한 사항
              <br />
              저희 서비스는 만14세 미만 아동의 개인정보를 처리하지 않습니다.
            </p>
            <p className="txt_noti">
              상기 각 동의별 보유기간에도 불구하고 관계 법령에 따라 추가 보유기간을 정하고 있는 경우그 기간까지 개인정보가 보관될 수 있으며, 이 경우 합리적 목적
              범위 내에서 최소의 개인정보가 보관됩니다.
            </p>
            <table className="tbl">
              <caption className="caption">[보유기간 달성 후 추가 보관되는 개인정보 현황]</caption>
              <thead>
                <tr>
                  <th>보관 사유</th>
                  <th>보관 근거 및 기간</th>
                  <th>보관 항목</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>소비자 불만 또는 분쟁처리 기록 보존의무 이행</td>
                  <td>「전자상거래 등에서의 소비자보호에 관한 법률」 제6조, 3년</td>
                  <td>이메일 주소, 문의 내용</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">2. 수집한 개인정보의 이용 및 제 3자 제공</strong>
          <p className="txt">
            저희 서비스는 고객님의 개인정보를 동의 받은 범위 내에서 사용하며, 해당 범위를 초과하여 이용하거나 타인 또는 다른 회사(기관)에 제공하지 않습니다. 단,
            법령에 정해진 의무 또는 수사목적으로 법령에서 정해진 절차와 방법에 따라 수사기관의 정당한 요청이 있는 경우 그 의무이행을 위해 해당 기관에 제공될 수
            있습니다.
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">3. 개인정보의 처리 위탁</strong>
          <p className="txt">
            회사는 고객님께 원활하고 안정적인 서비스를 제공하고 효율적인 업무처리를 위해 개인정보 처리를 외부 전문업체에 위탁할 수 있으나 현재 위탁하여 처리하는
            개인정보는 없습니다.{" "}
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">4. 개인정보의 국외 이전에 관한 사항</strong>
          <p className="txt">
            회사의 원활한 서비스 제공 목적 및 고객님의 편의 증진을 위하여 고객님의 정보를 국외로 이전할 수 있으나, 현재 국외로 이전되는 개인정보는 없습니다.
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">5. 개인정보 파기 절차 및 방법</strong>
          <p className="txt">
            회사는 수집한 개인정보에 대해 고객의 회원탈퇴, 서비스의 종료 또는 법정 의무 보유기간이 만료된 때에 지체없이 파기하며, 그 절차와 방법은 다음과
            같습니다.
          </p>
          <b className="txt">가) 파기 절차</b>
          <ul className="list_sub">
            <li>
              고객의 회원탈퇴 또는 별도의 동의철회 요청 등 대상 개인정보의 파기 사유가 발생된 경우, 개인정보별 법정 보유기간을 확인하고 별도의 안전한 DB에
              보관하며, 보관대상이 되지 않은 개인정보는 ‘나. 파기 방법’에 따라 파기합니다
            </li>
          </ul>
          <b className="txt">나) 파기 방법</b>
          <ul className="list_sub">
            <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각 ∙ 용해 등의 방법으로 재생불가하도록 파기하고 있습니다.</li>
            <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
          </ul>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">6. 정보주체 및 법정 대리인의 권리 ∙ 의무와 그 행사방법</strong>
          <div className="wrap_sub_detail">
            <p className="txt_num">
              <span className="num">1)</span> 회사에 제공한 본인의 개인정보는 가능한 최신의 상태가 유지될 수 있도록 수시로 업데이트 해주시기 바랍니다.
            </p>
            <p className="txt_num">
              <span className="num">2)</span> 정보주체(또는 만 14세 미만 아동의 법정 대리인)는 본인의 개인정보에 한해 열람·수정·삭제를 요청할 수 있으며, 회사는
              곧바로 이러한 요청에 필요한 조치를 하고 있습니다.
            </p>
            <span className="caption">[정보주체 및 법정대리인의 권리 행사 방법 안내]</span>
            <ul className="list_sub">
              <li>고객센터 이메일 : planetad_qna@skplanet.com</li>
              <li>
                본 개인정보처리방침 <b>’11. 개인정보보호책임자 및 담당자의 연락처’</b>를 통해 요청
              </li>
            </ul>
            <p className="txt_num">
              <span className="num">3)</span> 회사는 정보주체 또는 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보에 대해 관련 법과 정해진 규정에 따라
              안전하게 처리하고 그 외의 용도로 열람하거나 이용할 수 없도록 관리하고 있습니다.
            </p>
          </div>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">7. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</strong>
          <p className="txt">본 서비스는 고객님의 정보를 저장하고 수시로 찾아내는 쿠키(cookie)를 설치/운용하지 않습니다.</p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">8. 개인정보의 기술적/관리적 보호 대책</strong>
          <p className="txt">
            회사는 개인정보의 안전한 보호를 위하여 전문기관으로부터 주요 시스템과 설비에 대한 정보보호관리체계 인증을 받아 본 서비스를 운영하고 있습니다.
            고객님의 개인정보 보호를 위해 적용하고 있는 기술적 ∙ 관리적 대책은 다음과 같습니다.
          </p>
          <ul className="list_sub">
            <li>고객의 개인정보는 안전성이 확보된 공간에 암호화 하여 저장하고 있습니다.</li>
            <li>고객의 개인정보 및 기타 데이터는 네트워크상의 전송 구간을 암호화하여 안전성이 확보된 상태에서 전송되거나 수집되고 있습니다.</li>
            <li>
              회사는 컴퓨터 바이러스(Virus) 등 멀웨어(Malware)에 의한 피해를 방지하고자 백신 소프트웨어와 보안패치의 최신성을 유지하고 운영∙관리하고 있습니다.
            </li>
            <li>회사는 해킹 등 외부침입에 대비하여 각 서버마다 침입 차단 시스템과 취약점 분석 시스템을 이용하고 있습니다.</li>
            <li>
              회사는 고객의 개인정보가 저장된 공간 및 Database에 접근할 수 있는 관계자를 최소한으로 정하고 있으며, 접근기간을 관리하여 최대한의 안전성 확보를
              위해 노력하고 있습니다.
            </li>
            <li>
              회사는 개인정보 데이터에 접근할 수 있는 관계자에 대한 개인정보 보호에 관한 반복적인 교육을 통해 보안인식을 지속적으로 제고하고 필요한 정책과
              절차를 마련하여 안전성이 확보될 수 있는 체계적 시스템을 갖추어 운영하고 있습니다.
            </li>
            <li>
              회사는 기술 관리 상의 사고나 과실로 개인정보가 상실 · 유출 · 변조 · 훼손되었을 때 정보주체에 즉시 알리고 그에 대한 적절한 대책과 보상을 마련할
              것입니다.
            </li>
          </ul>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">9. 광고성 정보 전송</strong>
          <p className="txt">본 서비스는 영리목적의 광고성 정보를 전송하지 않습니다.</p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">10. 개인정보 관련 불편처리</strong>
          <div className="wrap_sub_detail">
            <p className="txt_num">
              <span className="num">1)</span> 본 서비스의 이용과 관련된 문의나 회사가 처리하는 개인정보에 대한 문의는 아래{" "}
              <b>‘11. 개인정보보호책임자 및 담당자의 연락처’</b>의 연락처를 이용하시기 바랍니다.
            </p>
            <p className="txt_num">
              <span className="num">2)</span> 또한 개인정보 침해에 대한 신고 및 구제, 상담이 필요하신 경우에는 한국인터넷진흥원(KISA) 개인정보 침해신고센터 등
              아래의 연락처를 이용해 문의하실 수 있습니다.
            </p>
            <ul className="list_sub">
              <li>개인정보 침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
              <li>개인정보 분쟁조정위원회(개인정보포털) : 1833-6972 (privacy.go.kr)</li>
              <li>대검찰청: (국번없이)1301, (www.spo.go.kr)</li>
              <li>경찰청: (국번없이)182 (ecrm.cyber.go.kr)</li>
            </ul>
          </div>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">11. 개인정보보호책임자 및 담당자의 연락처</strong>
          <p className="txt">회사는 고객의 개인정보 관련 문의사항 및 불편사항을 청취하기 위해 아래와 같이 개인정보 보호책임자 및 담당자를 지정하고 있습니다.</p>
          <dl className="list_disc">
            <dt>
              <span className="num">1</span>개인정보 보호 총괄책임자(Chief Privacy Officer)
            </dt>
            <dd>성명 및 직책 : 하현명 대외협력그룹장</dd>
            <dd>이메일 : planetad_qna@skplanet.com</dd>
          </dl>
          <dl className="list_disc">
            <dt>
              <span className="num">2</span>개인정보 보호 책임자
            </dt>
            <dd>성명 및 직책 : 탁형영 넥스트AD Tech담당</dd>
            <dd>이메일 : planetad_qna@skplanet.com</dd>
          </dl>
          <dl className="list_disc">
            <dt>
              <span className="num">3</span>개인정보 보호 담당자
            </dt>
            <dd>소속 및 성명 : 광고플랫폼팀 민혜수 매니저</dd>
            <dd>이메일 : planetad_qna@skplanet.com</dd>
          </dl>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">12. 행태정보의 수집∙이용∙제공 및 거부 등에 관한 사항</strong>
          <p className="txt">
            Planet AD 광고 플랫폼에서 맞춤형 광고 운영을 위해 행태 정보를 수집 및 이용하고 있으며, 관련 정책은 Planet AD 행태정보
            처리방침(https://web.planetad.co.kr/block) 및 운영하는 정책을 따릅니다.{" "}
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">13. 추가적인 이용 ∙ 제공 관련 판단 기준</strong>
          <p className="txt">
            회사는 「개인정보 보호법」 제15조제항 및 제17조제4항에 따라 당초 수집목적과의 관련성이 있는지 여부, 개인정보의 처리 관행에 비추어 볼 때 개인정보의
            추가적인 이용 또는 제공에 대한 예측 가능성 여부, 고객님의 이익을 부당하게 침해하는지 여부, 가명처리 또는 암호화 등 안전성 확보 조치 여부를 고려하여
            고객님의 동의 없이 개인정보를 추가적으로 이용 ∙ 제공할 수 있지만, 현재 개인정보의 추가적인 이용 ∙ 제공을 하는 경우는 없습니다.
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">14. 가명정보 처리에 관한 사항</strong>
          <p className="txt">
            회사는 통계작성, 과학적 연구, 공익적 기록보존 등 법령에서 정한 목적달성을 위하여 고객님의 개인정보를 가명처리 할 수 있으나, 현재 가명처리하는
            개인정보는 없습니다.
          </p>
        </div>
        <div className="wrap_detail">
          <strong className="txt_title">15. 알릴 의무</strong>
          <p className="txt">
            현 개인정보처리방침은 2023년 8월 28일에 제정되었으며 회사의 개인정보 보호 정책이나 운영현황의 변경으로 내용이 추가, 삭제, 수정될 때에는 개정 최소
            7일 전부터 공지사항을 통해 알릴 것 입니다.
          </p>
        </div>
      </>
    ),
  },
  {
    revision: "2024년 11월 20일",
    content: (
      <>
        <>
          <p className="txt">
            본 개인정보처리방침은 SK플래닛 주식회사(이하 “회사”라 함)가 제공하는 “Planet AD”서비스” (이하 ‘서비스’라 합니다)가 고객님께 서비스를 제공하는
            과정에서 수집 · 저장되어 처리하고 있는 개인정보의 관리 방법과 현황에 대해 안내드릴 목적으로 제정 · 운영되고 있습니다.
          </p>
          <br />
          <p className="txt">
            회사는 주요 개인정보 처리 관련 정보를 아래와 같이 라벨링을 활용하여 제공함으로써 정보주체인 고객님이 개인정보처리방침을 보다 쉽게 이해할 수 있도록
            노력하고 있습니다.
          </p>
          <br />
          <table className="tbl">
            <caption className="caption">[주요 개인정보 처리 표시(라벨링)]</caption>
            <thead>
              <tr>
                <th>개인정보 수집</th>
                <th>
                  개인정보
                  <br />
                  처리 목적
                </th>
                <th>고증처리 부서</th>
              </tr>
            </thead>
            <tbody className="align-base">
              <tr>
                <td>
                  <img src={PersonalImg} alt="개인정보 수집" className="img_labeling" />
                  이메일, 문의내용 ※ 세부 내용은 개인정보처리방침 본문에서 확인
                </td>
                <td>
                  <img src={ProcessingImg} alt="개인정보 처리 목적" className="img_labeling" />
                  광고 적립금 관련 고객 문의사항 처리 ※ 세부 내용은 개인정보처리방침 본문에서 확인
                </td>
                <td>
                  <img src={QnaImg} alt="고증처리 부서" className="img_labeling" />
                  개인정보 관련 문의, 불만처리, 피해 구제 등에 관한 고객의 요청은 아래 경로를 통해 문의주시면 신속하고 성실하게 답변해 드리고 있습니다. 고객센터
                  이메일 : planetad_qna@skplanet.com ※ 세부 내용은 개인정보처리방침 본문에서 확인
                </td>
              </tr>
            </tbody>
          </table>
          <ol>
            <li>개인정보 처리 현황</li>
            <li>수집한 개인정보의 이용 및 제3자 제공</li>
            <li>개인정보의 처리 위탁</li>
            <li>개인정보의 국외 이전에 관한 사항</li>
            <li>개인정보 파기 절차 및 방법</li>
            <li>정보주체의 권리 · 의무와 그 행사방법</li>
            <li>개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</li>
            <li>개인정보의 안정성 확보조치에 관한 사항</li>
            <li>개인정보 관련 불편처리</li>
            <li>개인정보보호책임자 및 담당자의 연락처</li>
            <li>행태정보의 수집 · 이용 · 제공 및 거부 등에 관한 사항</li>
            <li>추가적인 이용 · 제공 관련 판단 기준</li>
            <li>가명정보 처리에 관한 사항</li>
            <li>개인위치정보 수집 · 이용 · 제공 등에 관한 사항</li>
            <li>알릴의무</li>
          </ol>
          <p className="txt">
            회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보보호법」 등 개인정보 보호에 관한 국내법에 따라 고객의 개인정보를 안전하게
            관리하기 위한 최선의 노력을 다하고 있으며, 각 각의 구체적인 관리방법은 다음과 같습니다.
          </p>
          <hr />
          <div className="wrap_detail">
            <div className="wrap_sub">
              <p className="txt_num">
                <span className="num">1)</span> 회사는 적법하고 공정한 수단으로 회원님의 개인정보를 수집하고 있습니다.
              </p>
              <p className="txt_num">
                <span className="num">2)</span> 수집하는 개인정보는 서비스 제공에 필요한 최소한의 정보만으로 한정되며, 회원님의 기본적 인권을 침해할 우려가 있는
                민감한 개인정보(※법정 기준 또는 정의에 따름)는 수집하지 않습니다.
              </p>
              <p className="txt_num">
                <span className="num">3)</span> 회사는 법령의 수집 근거나 고객동의를 근거로 다음과 같은 개인정보를 수집하고 있으며 보유기간 만료 시 복구
                불가능한 방법으로 안전하게 파기하고 있습니다.
              </p>
              <table className="tbl">
                <caption className="caption">[필수] 개인정보 수집/이용</caption>
                <thead>
                  <tr>
                    <th>처리 근거</th>
                    <th>이용 목적</th>
                    <th>수집 항목</th>
                    <th>보유기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>개인정보법 제 15 조제 1 항제 1 호(회원동의) 및 제 4 호(계약의 이행)</td>
                    <td>광고 적립금 관련 고객 문의사항 처리</td>
                    <td>이메일, 문의 내용</td>
                    <td>문의일로부터 3년 보관 후 파기</td>
                  </tr>
                </tbody>
              </table>
              <p className="txt_num">
                <span className="num">4)</span> 회사는 만 14 세 미만 아동의 개인정보를 처리하지 않습니다.
              </p>
              <p className="txt_num">
                <span className="num">5)</span> 회사는 제공하는 서비스에 따라 적용되는 각각의 법령을 준수하여 개인신용정보를 보관하고 있습니다.
              </p>
              <table className="tbl">
                <thead>
                  <tr>
                    <th>보관 사유</th>
                    <th>보관 근거 및 기간</th>
                    <th>보관 항목</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>소비자 불만 또는 분쟁처리 기록 보존의무 이행</td>
                    <td>「전자상거래 등에서의 소비자보호에 관한 법률」 제6조, 3년</td>
                    <td>이메일 주소, 문의 내용</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">2. 수집한 개인정보의 이용 및 제 3자 제공</strong>
            <p className="txt">
              회사는 고객님의 개인정보를 동의 받은 범위 내에서 사용하며, 해당 범위를 초과하여 이용하거나 타인 또는 다른 회사(기관)에 제공하지 않습니다. 단,
              법령에 정해진 의무 또는 수사목적으로 법령에서 정해진 절차와 방법에 따라 수사기관의 정당한 요청이 있는 경우 그 의무이행을 위해 해당 기관에 제공될
              수 있습니다.
            </p>
            <br />
            <p className="txt">
              회사는 정부 관계부처가 합동으로 발표한 「긴급상황 시 개인정보 처리 및 보호수칙」에 따라 재난, 감염병, 급박한 생명·신체 위험을 초래하는 사건·사고,
              급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다. 자세한 사항은 아래 URL을 통해
              확인하시기 바랍니다.
            </p>
            <a
              href="https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS217&mCode=G010030000&nttId=7641"
              target="_blank"
              className="link"
              rel="noreferrer"
            >
              https://www.pipc.go.kr/np/cop/bbs/selectBoardArticle.do?bbsId=BS217&mCode=G010030000&nttId=7641
            </a>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">3. 개인정보의 처리 위탁</strong>
            <p className="txt">
              회사는 고객님께 원활하고 안정적인 서비스를 제공하고 효율적인 업무처리를 위해 개인정보 처리를 외부 전문업체에 위탁할 수 있으나 현재 위탁하여
              처리하는 개인정보는 없습니다.{" "}
            </p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">4. 개인정보의 국외 이전에 관한 사항</strong>
            <p className="txt">
              회사의 고객의 동의 또는 관련 법령에 근거하여 개인정보를 국외로 제공되거나, 원활한 서비스 제공 목적으로 고객님의 정보를 국외로 이전할 수 있으며, 이
              경우 현황을 공개하고 있습니다. 다만 현재 국외로 이전되는 개인정보는 없습니다.
            </p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">5. 개인정보 파기 절차 및 방법</strong>
            <p className="txt">
              회사는 수집한 개인정보에 대해 고객의 회원탈퇴, 서비스의 종료 또는 법정 의무 보유기간이 만료된 때에 지체없이 파기하며, 그 절차와 방법은 다음과
              같습니다.
            </p>
            <b className="txt">가) 파기 절차</b>
            <ul className="list_sub">
              <li>
                고객의 회원탈퇴 또는 별도의 동의철회 요청 등 대상 개인정보의 파기 사유가 발생된 경우, 개인정보별 법정 보유기간을 확인하고 별도의 안전한 DB에
                보관하며, 보관대상이 되지 않은 개인정보는 ‘나. 파기 방법’에 따라 파기합니다
              </li>
            </ul>
            <b className="txt">나) 파기 방법</b>
            <ul className="list_sub">
              <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각 ∙ 용해 등의 방법으로 재생불가하도록 파기하고 있습니다.</li>
              <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
            </ul>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">6. 정보주체의 권리 ∙ 의무와 그 행사방법</strong>
            <div className="wrap_sub_detail">
              <p className="txt_num">
                <span className="num">1)</span> 회사에 제공한 본인의 개인정보는 가능한 최신의 상태가 유지될 수 있도록 수시로 업데이트 해주시기 바랍니다.
              </p>
              <p className="txt_num">
                <span className="num">2)</span> 정보주체는 본인의 개인정보에 한해 열람 · 수정 · 삭제 ∙ 처리정지 및 철회 요구, 자동화된 결정에 대한 거부 또는
                설명 요구를 할 수 있으며, 회사는 곧바로 이러한 요청에 필요한 조치를 하고 있습니다.
              </p>
              <span className="caption">[정보주체 및 법정대리인의 권리 행사 방법 안내]</span>
              <ul className="list_sub">
                <li>고객센터 이메일 : planetad_qna@skplanet.com</li>
                <li>
                  본 개인정보처리방침 <b>’10. 개인정보보호책임자 및 담당자의 연락처’</b>를 통해 요청
                </li>
              </ul>
              <p className="txt_num">
                <span className="num">3)</span> 회사는 정보주체의 요청에 의해 해지 또는 삭제된 개인정보에 대해 관련 법과 정해진 규정에 따라 안전하게 처리하고 그
                외의 용도로 열람하거나 이용할 수 없도록 관리하고 있습니다.
              </p>
              <p className="txt_num">
                <span className="num">4)</span> 자동화된 결정이 이루어진다는 사실에 대해 정보주체의 동의를 받았거나, 계약 등을 통해 미리 알린 경우, 법률의
                규정에 따라 처리되는 경우에는 자동화된 결정에 대한 거부는 인정되지 않으며, 설명 및 검토 요구만 가능합니다. 또한 자동화된 결정에 대한 거부∙설명
                요구는 다른사람의 생명 ∙ 신체 ∙ 재산과 그밖의 이익을 부당하게 침해할 우려가 있는 등 정당한 사유가 있는 경우에는 그 요구가 거절될 수 있습니다.
              </p>
            </div>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">7. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</strong>
            <p className="txt">본 서비스는 고객님의 정보를 저장하고 수시로 찾아내는 쿠키(cookie)를 설치/운용하지 않습니다.</p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">8. 개인정보의 안전성 확보 조치에 관한 사항</strong>
            <p className="txt">
              회사는 개인정보의 안전한 보호를 위하여 전문기관으로부터 주요 시스템과 설비에 대한 정보보호관리체계 인증을 받아 본 서비스를 운영하고 있습니다.
              고객님의 개인정보 보호를 위해 적용하고 있는 안전성 확보 조치는 다음과 같습니다.
            </p>
            <ul className="list_sub">
              <li>고객의 개인정보는 안전성이 확보된 공간에 암호화 하여 저장하고 있습니다.</li>
              <li>고객의 개인정보 및 기타 데이터는 네트워크상의 전송 구간을 암호화하여 안전성이 확보된 상태에서 전송되거나 수집되고 있습니다.</li>
              <li>
                회사는 컴퓨터 바이러스(Virus) 등 멀웨어(Malware)에 의한 피해를 방지하고자 백신 소프트웨어와 보안패치의 최신성을 유지하고 운영∙관리하고 있습니다.
              </li>
              <li>회사는 해킹 등 외부침입에 대비하여 각 서버마다 침입 차단 시스템과 취약점 분석 시스템을 이용하고 있습니다.</li>
              <li>
                회사는 고객의 개인정보가 저장된 공간 및 Database에 접근할 수 있는 관계자를 최소한으로 정하고 있으며, 접근기간을 관리하여 최대한의 안전성 확보를
                위해 노력하고 있습니다.
              </li>
              <li>
                회사는 개인정보 데이터에 접근할 수 있는 관계자에 대한 개인정보 보호에 관한 반복적인 교육을 통해 보안인식을 지속적으로 제고하고 필요한 정책과
                절차를 마련하여 안전성이 확보될 수 있는 체계적 시스템을 갖추어 운영하고 있습니다.
              </li>
              <li>
                회사는 기술 관리 상의 사고나 과실로 개인정보가 상실 · 유출 · 변조 · 훼손되었을 때 정보주체에 즉시 알리고 그에 대한 적절한 대책과 보상을 마련할
                것입니다.
              </li>
            </ul>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">9. 개인정보 관련 불편처리</strong>
            <div className="wrap_sub_detail">
              <p className="txt_num">
                <span className="num">1)</span> 본 서비스의 이용과 관련된 문의나 회사가 처리하는 개인정보에 대한 문의는 아래{" "}
                <b>’10. 개인정보보호책임자 및 담당자의 연락처’</b>의 연락처를 이용하시기 바랍니다.
              </p>
              <p className="txt_num">
                <span className="num">2)</span> 또한 개인정보 침해에 대한 신고 및 구제, 상담이 필요하신 경우에는 한국인터넷진흥원(KISA) 개인정보 침해신고센터 등
                아래의 연락처를 이용해 문의하실 수 있습니다.
              </p>
              <ul className="list_sub">
                <li>개인정보 침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
                <li>개인정보 분쟁조정위원회 : 1833-6972 (privacy.go.kr)</li>
                <li>대검찰청: (국번없이)1301, (www.spo.go.kr)</li>
                <li>경찰청: (국번없이)182 (ecrm.cyber.go.kr)</li>
              </ul>
            </div>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">10. 개인정보보호책임자 및 담당자의 연락처</strong>
            <p className="txt">
              회사는 고객의 개인정보 관련 문의사항 및 불편사항을 청취하기 위해 아래와 같이 개인정보 보호책임자 및 담당자를 지정하고 있습니다.
            </p>
            <dl className="list_disc">
              <dt>
                <span className="num">1</span>개인정보 보호 총괄책임자(Chief Privacy Officer)
              </dt>
              <dd>성명 및 직책 : 하현명 Compliance Unit장</dd>
              <dd>이메일 : planetad_qna@skplanet.com</dd>
            </dl>
            <dl className="list_disc">
              <dt>
                <span className="num">2</span>개인정보 보호 책임자
              </dt>
              <dd>성명 및 직책 : 탁형영 광고그룹장</dd>
              <dd>이메일 : planetad_qna@skplanet.com</dd>
            </dl>
            <dl className="list_disc">
              <dt>
                <span className="num">3</span>개인정보 보호 담당자
              </dt>
              <dd>소속 및 성명 : 광고사업2팀 민혜수 매니저</dd>
              <dd>이메일 : planetad_qna@skplanet.com</dd>
            </dl>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">11. 행태정보의 수집 ∙ 이용 ∙ 제공 및 거부 등에 관한 사항</strong>
            <p className="txt">
              Planet AD 광고 플랫폼에서 맞춤형 광고 운영을 위해 행태 정보를 수집 및 이용하고 있으며, 관련 정책은 Planet AD 행태정보 처리방침 및 운영하는 정책을
              따릅니다.
            </p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">12. 추가적인 이용 ∙ 제공 관련 판단 기준</strong>
            <p className="txt">회사는 「개인정보 보호법」 제15조제3항 및 제17조제4항에 해당하는 개인정보의 추가적인 이용 · 제공이 없습니다.</p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">13. 가명정보 처리에 관한 사항</strong>
            <p className="txt">회사는 현재 본 서비스에서 수집된 개인정보를 이용한 가명처리 및 가명정보 처리는 없습니다.</p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">14. 개인위치정보 수집·이용·제공 등에 관한 사항</strong>
            <p className="txt">본 서비스에서는 고객님의 개인위치정보를 활용하는 서비스를 제공하지 않습니다.</p>
          </div>
          <div className="wrap_detail">
            <strong className="txt_title">15. 알릴 의무</strong>
            <p className="txt">
              현 개인정보처리방침은 2024년 11월 20일에 제정되었으며 회사의 개인정보 보호 정책이나 운영 현황의 변경으로 내용이 추가, 삭제, 수정될 때에는 개정
              최소 7일 전부터 공지사항을 통해 알릴 것 입니다.
            </p>
          </div>
        </>
      </>
    ),
  },
];

export default privacies;
